import styled from '@emotion/styled'
import { calcRem, colors } from '../../../__styling'
import { CardMedia } from '../../../cards/CardMedia/CardMedia'

export const StyledItem = styled('div')({
    position: 'relative',
    width: calcRem(238),
    minWidth: calcRem(238),
    height: 'auto',
    aspectRatio: '9 / 16',
    borderRadius: calcRem(12),
    overflow: 'hidden',
    flexShrink: 0,
    background: colors.black,
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
    '&:hover': {
        opacity: '0.7',
    },
})

export const StyledSkeletonItem = styled(StyledItem)({
    cursor: 'default',
    '&:hover': {
        opacity: 1,
    },
})

export const StyledVerticalCardMedia = styled(CardMedia)({
    width: '100%',

    '& [class*="StyledPlayIcon"], & [class*="StyledMediaIndicator"]': {
        display: 'none',
    },
})

export const StyledGradient = styled('div')({
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '45%',
    background:
        'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.95) 100%)',
    pointerEvents: 'none',
})

export const StyledSkeletonMedia = styled('div')({
    position: 'absolute',
    inset: 0,
    '& [class*="StyledSkeleton"]': {
        margin: 0,
        display: 'block',
        height: '100%',
        width: '100%',
    },
})

export const StyledMeta = styled('div')({
    position: 'absolute',
    left: calcRem(12),
    right: calcRem(12),
    bottom: calcRem(12),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: colors.white,
    textShadow: '0 1px 2px rgba(0,0,0,0.6)',
})

export const StyledTitle = styled('span')({
    fontSize: calcRem(16),
    lineHeight: 1.25,
    fontWeight: 600,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
})

export const StyledDuration = styled('span')({
    marginTop: calcRem(4),
    fontSize: calcRem(14),
    opacity: 0.85,
})

export const StyledArrow = styled('button')({
    position: 'absolute',
    top: '50%',
    left: calcRem(8),
    transform: 'translateY(-50%) rotate(180deg)',
    width: calcRem(32),
    height: calcRem(32),
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.15)',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
})
